(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-wj-blog]').forEach(blog => {
      if (blog.dataset.wjReady) return;
      blog.dataset.wjReady = 'true';
      let controller;
      blog.addEventListener('click', async event => {
        const link = event.target.closest('.wj-room-filters a, .wj-journal-filter a, .wj-room-chips a, .wj-journal-pagination a');
        if (!link || !link.hasAttribute('href') || link.getAttribute('aria-disabled') === 'true' || !blog.contains(link) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const wasPagination = Boolean(link.closest('.wj-journal-pagination'));
        const url = new URL(link.getAttribute('href'), wasPagination ? (blog.dataset.wjCurrentUrl || window.location.href) : window.location.href);
        if (url.origin !== window.location.origin || ![blog.dataset.blogUrl, blog.dataset.blogUrl + '/'].includes(url.pathname) && !url.pathname.startsWith(blog.dataset.blogUrl + '/tagged/')) return;
        event.preventDefault();
        if (controller) controller.abort();
        controller = new AbortController();
        const request = controller;
        const results = blog.querySelector('[data-wj-blog-results]');
        const status = blog.querySelector('[data-wj-filter-status]');
        const timeout = setTimeout(() => request.abort(), 20000);
        results.setAttribute('aria-busy', 'true');
        status.textContent = blog.dataset.loading;
        url.searchParams.set('section_id', blog.dataset.sectionId);
        try {
          const response = await fetch(url, {signal:request.signal});
          if (!response.ok) throw new Error('Section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector('[data-wj-blog-results]');
          if (!next) throw new Error('Section missing');
          if (request !== controller) return;
          results.replaceChildren(...next.childNodes);
          url.searchParams.delete('section_id');
          blog.dataset.wjCurrentUrl = url.href;
          status.textContent = blog.dataset.loaded;
          if (wasPagination) {
            const grid = results.querySelector('.wj-journal-grid, .wj-journal-empty');
            if (grid) {grid.tabIndex = -1;grid.focus({preventScroll:true});grid.scrollIntoView({block:'start',behavior:'smooth'});}
          } else {
            const active = results.querySelector('.wj-room-filters [aria-current]');
            if (active) active.focus({preventScroll:true});
          }
        } catch (error) {
          if (request === controller) status.textContent = blog.dataset.loadError;
        } finally {
          clearTimeout(timeout);
          if (request === controller) results.removeAttribute('aria-busy');
        }
      });
    });
    root.querySelectorAll('[data-wj-article-body]').forEach(body => {
      if (body.dataset.wjReady) return;
      body.dataset.wjReady = 'true';
      const article = body.closest('article');
      if (!article) return;
      const firstHeading = body.querySelector('h2');
      for (const paragraph of body.querySelectorAll('p')) {
        const label = paragraph.querySelector(':scope > strong');
        if (label && /^Kurzantwort\s*:/i.test(label.textContent.trim()) && (!firstHeading || (paragraph.compareDocumentPosition(firstHeading) & Node.DOCUMENT_POSITION_FOLLOWING))) {
          paragraph.classList.add('wj-answer-box');
          break;
        }
      }
      const headings = [...body.querySelectorAll('h2')].filter(heading => !heading.closest('[data-wj-product]'));
      const toc = article.querySelector('[data-wj-toc]');
      if (toc && headings.length > 1) {
        const list = toc.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `wohnjoy-abschnitt-${index + 1}`;
            while (document.getElementById(id)) id += '-x';
            heading.id = id;
          }
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent;
          const item = document.createElement('li');
          item.append(link);list.append(item);
          if (['Autor', 'Autor und Erstellung'].includes(heading.textContent.trim())) {
            const box = document.createElement('section');
            box.className = 'wj-author-box';
            heading.before(box);box.append(heading);
            let next = box.nextElementSibling;
            while (next && /^(P|UL|OL)$/.test(next.tagName) && !next.matches('[data-wj-product]')) {
              const following = next.nextElementSibling;box.append(next);next = following;
            }
          }
        });
        toc.hidden = false;
        toc.open = window.matchMedia('(min-width: 768px)').matches;
      }
    });
    root.querySelectorAll('[data-wj-share]').forEach(share => {
      if (share.dataset.wjReady) return;
      share.dataset.wjReady = 'true';
      const status = share.querySelector('[role="status"]');
      const copy = share.querySelector('[data-wj-copy]');
      const native = share.querySelector('[data-wj-share-button]');
      if (navigator.clipboard && window.isSecureContext) {
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          try {await navigator.clipboard.writeText(share.dataset.url);status.textContent = share.dataset.copied;}
          catch {status.textContent = share.dataset.copyFailed;}
        });
      }
      if (navigator.share) {
        native.hidden = false;
        native.addEventListener('click', async () => {
          try {await navigator.share({title:share.dataset.title,url:share.dataset.url});}
          catch (error) {if (error.name !== 'AbortError') status.textContent = share.dataset.copyFailed;}
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
